import type { RectangleButtonProps } from './RectangleButton';

import { css, styled } from 'styled-components';

import { ButtonContent } from '../Button';

import { DefaultRectangleButtonSC } from './RectangleButton';

type ColorVariant = 'light' | 'dark';

type Props = RectangleButtonProps & {
  colorVariant?: ColorVariant;
};

const darkColorVariant = css`
  color: ${(props) => props.theme.colors.white};

  &:hover {
    background-color: ${(props) => props.theme.colors.oxfordBlue[80]};
  }
`;

const lightColorVariant = css`
  color: ${(props) => props.theme.colors.oxfordBlue[100]};

  &:hover {
    background-color: ${(props) => props.theme.colors.shadows.emeraldGreen[20]};
  }
`;

const SecondaryButtonSC = styled(DefaultRectangleButtonSC)<{ $colorVariant?: ColorVariant }>`
  ${(props) => {
    switch (props.$colorVariant) {
      case 'dark':
        return darkColorVariant;
      default:
        return lightColorVariant;
    }
  }}

  background-color: inherit;

  &:disabled {
    color: ${(props) => props.theme.colors.shadows.oxfordBlue[80]};
    background: ${(props) => props.theme.colors.shadows.oxfordBlue[30]};
  }
`;

export const SecondaryRectangleButton = ({ children, colorVariant, leftIcon, rightIcon, topIcon, ...props }: Props) => {
  return (
    <SecondaryButtonSC $colorVariant={colorVariant} {...props}>
      <ButtonContent leftIcon={leftIcon} rightIcon={rightIcon} topIcon={topIcon}>
        {children}
      </ButtonContent>
    </SecondaryButtonSC>
  );
};
